module.exports = require('../dist/components/Title/Title');
